import { DAYS_PER_YEAR, SECOND_PER_DAY } from '../constants'
import { FixStakedPosition, FormattedFixStakedPosition } from '../types/fix-staked-position'
import { FlexStakedPosition, FormattedFlexStakedPosition } from '../types/flex-staked-position'
import { UnstakePosition } from '../types/unstake-position'
import { FormattedUnstakePosition } from '../types/unstake-position'
import { format, formatPercentage } from './number-helpers'
import { formatRemainingTime, secondsToDays } from './time-helpers'

export const checkIfLockupStaked = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lockupStakingInfo: any,
  connected: boolean,
) => {
  return connected && !!lockupStakingInfo?.lockupStakingAccounts?.length
}

export const checkIfExistUnstakePosition = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userFlexibleStakingInfo: any,
  connected: boolean,
) => {
  return connected && !!userFlexibleStakingInfo?.withdrawPositions?.length
}

export const convertOnChainFixedAprToPercentage = (apr: number) => {
  // 5% fixed apr -> 500 on chain
  return apr / 10000
}

export const calculateEstDailyReward = (apr: string, stakedAmount: string): string => {
  const dailyReward = (Number(apr) / 100 / 365) * Number(stakedAmount)
  return dailyReward.toFixed(2)
}

export const calculateEstFixedReward = (
  aprInPercentage: number,
  stakedAmount: number,
  durationInSeconds: number,
): number => {
  const dailyReward = (aprInPercentage / DAYS_PER_YEAR) * stakedAmount
  return dailyReward * (durationInSeconds / SECOND_PER_DAY)
}

export const formatFixStakedPosition = (position: FixStakedPosition): FormattedFixStakedPosition => {
  return {
    ...position,
    formattedLockedAmount: format(position.lockedAmount, true, 2),
    formattedEstApr: formatPercentage(position.estApr * 100, false, 2),
    formattedLockPeriod: secondsToDays(position.lockPeriodInSeconds) + ' days',
    formattedRemainingTime: formatRemainingTime(position.remainingSeconds),
    formattedEstReward: format(position.estReward, true, 4) + ' ' + position.tokenSymbol,
  }
}

export const formatFlexStakedPosition = (position: FlexStakedPosition): FormattedFlexStakedPosition => {
  return {
    ...position,
    formattedAmount: format(position.amount, true, 2),
    formattedEstApr: formatPercentage(position.estApr, false, 2),
    formattedEstReward: format(position.estReward, true, 4) + ' ' + position.tokenSymbol,
    formattedRemainingTime: formatRemainingTime(position.remainingSeconds),
  }
}

export const formatUnstakePosition = (position: UnstakePosition): FormattedUnstakePosition => {
  return {
    ...position,
    formattedRemainingTime: formatRemainingTime(position.remainingSeconds),
  }
}
